import {stockAdjustmentsList, stockAdjustmentsListDescription} from './list';

export const stockAdjustments = [
  {
    stockAdjustmentsList,
    stockAdjustmentsListDescription,
  },
];
